/* ============================================================
   Summer Sample Sale — self-contained behavior
   No dependency on the theme's JS. Init-guarded so it can't
   double-run, and re-inits inside the theme editor.
   ============================================================ */
(function () {
  'use strict';

  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function fmtTime(s){ s = Math.max(0, Math.floor(s)); return Math.floor(s/60) + ':' + pad(s % 60); }

  function init(root){
    if (!root || root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    /* ---------------- Audio previews ---------------- */
    var audio = new Audio();
    var current = null;            // the .ss-cell currently loaded
    var CIRC = 169.6;              // 2 * PI * r(27)

    function resetCell(cell){
      if (!cell) return;
      cell.classList.remove('is-playing');
      var ring = cell.querySelector('.ss-rec-prog');
      if (ring) ring.setAttribute('stroke-dashoffset', CIRC);
      var sub = cell.querySelector('.ss-psub');
      if (sub && sub.dataset.num) sub.textContent = sub.dataset.num + ' \u00b7 preview';
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.ss-rec');
      if (!btn || !root.contains(btn)) return;
      var cell = btn.closest('.ss-cell');
      var url = btn.getAttribute('data-audio');
      if (!url) return;

      if (current === cell) {
        if (audio.paused) { audio.play().catch(function(){}); cell.classList.add('is-playing'); }
        else { audio.pause(); cell.classList.remove('is-playing'); }
        return;
      }
      if (current) resetCell(current);
      current = cell;
      audio.src = url;
      audio.currentTime = 0;
      audio.play().catch(function(){});
      cell.classList.add('is-playing');
    });

    audio.addEventListener('timeupdate', function () {
      if (!current) return;
      var ring = current.querySelector('.ss-rec-prog');
      var sub = current.querySelector('.ss-psub');
      var d = audio.duration || 0;
      var frac = d ? (audio.currentTime / d) : 0;
      if (ring) ring.setAttribute('stroke-dashoffset', (CIRC * (1 - frac)).toFixed(1));
      if (sub) sub.textContent = (sub.dataset.num || '') + ' \u00b7 ' + fmtTime(audio.currentTime);
    });
    audio.addEventListener('ended', function () { resetCell(current); current = null; });

    /* ---------------- Add to cart ---------------- */
    root.addEventListener('click', function (e) {
      var cta = e.target.closest('.ss-cta');
      if (!cta || !root.contains(cta) || cta.disabled) return;
      var id = cta.getAttribute('data-variant');
      if (!id) return;
      e.preventDefault();
      var original = cta.textContent;
      cta.disabled = true;
      cta.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        window.location.href = (cta.getAttribute('data-checkout') === 'true') ? '/checkout' : '/cart';
      })
      .catch(function () {
        cta.disabled = false;
        cta.textContent = original;
        alert('Sorry — that could not be added to your cart.');
      });
    });

    /* ---------------- Countdown + sticky bar ---------------- */
    var endStr = root.getAttribute('data-timer-end');
    var endTime = endStr ? Date.parse(endStr.trim().replace(' ', 'T')) : NaN;
    var units = root.querySelectorAll('[data-unit]');
    var sbTime = root.querySelector('.ss-sb-time');

    function tick(){
      var diff = endTime - Date.now();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;
      units.forEach(function (u) {
        var k = u.getAttribute('data-unit');
        u.textContent = pad(k === 'd' ? d : k === 'h' ? h : k === 'm' ? m : s);
      });
      if (sbTime) sbTime.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    if (!isNaN(endTime)) { tick(); setInterval(tick, 1000); }

    var sticky = root.querySelector('.ss-stickybar');
    var banner = root.querySelector('.ss-banner');
    if (sticky && banner) {
      var onScroll = function () {
        if (banner.getBoundingClientRect().bottom <= 0) sticky.classList.add('is-pinned');
        else sticky.classList.remove('is-pinned');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------------- Sale shelf arrows ---------------- */
    root.querySelectorAll('[data-shelf-prev],[data-shelf-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var shelf = root.querySelector('.ss-sale-grid');
        if (!shelf) return;
        shelf.scrollBy({ left: btn.hasAttribute('data-shelf-next') ? 320 : -320, behavior: 'smooth' });
      });
    });

    /* ---------------- What's inside panels ---------------- */
    var insideWraps = root.querySelectorAll('.ss-inside');
    insideWraps.forEach(function (wrap) {
      var btn = wrap.querySelector('.ss-inside-toggle');
      var panel = wrap.querySelector('.ss-inside-panel');
      if (!btn || !panel) return;
      if (wrap.classList.contains('is-open')) panel.style.maxHeight = panel.scrollHeight + 'px';
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
      });
    });
    window.addEventListener('resize', function () {
      insideWraps.forEach(function (wrap) {
        if (!wrap.classList.contains('is-open')) return;
        var panel = wrap.querySelector('.ss-inside-panel');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  function boot(){ document.querySelectorAll('#summer-sale').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('#summer-sale') : null;
    if (el) { el.removeAttribute('data-ss-init'); init(el); }
  });
})();